import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState } from 'react';
import { useCallback } from 'preact/compat';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import useDidMount from 'beautiful-react-hooks/useDidMount';
import { Wrapper } from './styles';
function Wallet(props) {
    const { analyticsTitle, analyticsUrl, analyticsPath, title, products, handleAppleDidFail, handleGoogleDidFail, appleHidden, googleHidden, } = props;
    const [isWorking, setIsWorking] = useState(false);
    const triggerAddToWallet = useCallback((type) => {
        setIsWorking(true);
        window.dispatchEvent(new CustomEvent(`${type}.wallet`, {
            detail: products,
        }));
        return true;
    }, [products]);
    const onAppleFailed = useGlobalEvent('apple.wallet.failed');
    const onGoogleFailed = useGlobalEvent('google.wallet.failed');
    const onWalletSuccess = useGlobalEvent('wallet.success');
    const onWalletError = useGlobalEvent('wallet.error');
    const onWalletCancel = useGlobalEvent('wallet.cancel');
    const sendToAnalytics = useCallback(() => {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'page_view', {
                page_title: `${analyticsTitle} - Mobile payment`,
                page_location: `${analyticsUrl}complete`,
                page_path: `${analyticsPath}complete`,
                send_to: 'UA-44012490-1',
            });
        }
    }, [analyticsPath, analyticsTitle, analyticsUrl]);
    const handleWalletError = useCallback(() => {
        setIsWorking(false);
    }, [setIsWorking]);
    const handleWalletSuccess = useCallback(() => {
        handleWalletError();
        sendToAnalytics();
    }, [handleWalletError, sendToAnalytics]);
    const handleGoogleFailed = useCallback(() => {
        if (handleGoogleDidFail) {
            handleGoogleDidFail(true);
        }
    }, [googleHidden]);
    const handleAppleFailed = useCallback(() => {
        if (handleAppleDidFail) {
            handleAppleDidFail(true);
        }
    }, [appleHidden]);
    onGoogleFailed(handleGoogleFailed);
    onAppleFailed(handleAppleFailed);
    onWalletSuccess(handleWalletSuccess);
    onWalletError(handleWalletError);
    onWalletCancel(handleWalletError);
    const handleDidMount = useCallback(() => {
        window.dispatchEvent(new Event('WalletButtonsLoaded'));
    }, []);
    useDidMount(handleDidMount);
    if (appleHidden && googleHidden) {
        return null;
    }
    return (_jsxs(Wrapper, { className: "wallet", children: [!appleHidden && (_jsxs("button", { className: "wallet-btn", type: "button", disabled: isWorking, onClick: () => triggerAddToWallet('apple'), children: [_jsx("img", { src: "/assets/images/icon--apple-wallet.png", alt: "Apple Wallet" }), "Add to Apple Wallet"] })), !googleHidden && (_jsxs("button", { className: "wallet-btn", type: "button", disabled: isWorking, onClick: () => triggerAddToWallet('google'), children: [_jsx("img", { src: "/assets/images/icon--google-wallet.png", alt: "Google Wallet" }), "Add to Google Wallet"] }))] }));
}
Wallet.defaultProps = {
    analyticsTitle: 'Add to Wallet',
    analyticsUrl: 'https://www.snowdome.co.uk/',
    analyticsPath: '/',
    title: undefined,
};
export default Wallet;
